import Link from "components/Link";
import { greybackground, pagePadding } from "data/commonClasses";
import {
  createPassword,
  fetchFromAPI,
  handleNumber,
  handleRouter,
  setCookie,
} from "functions";
import { useContext, useState } from "react";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";
import Button from "./Button";
import Input from "./Input";
import Text from "./Text";
import SessionContext from "./session/SessionContext";

export default function SetPassword(props) {
  const { t } = useTranslation();

  let {
    actions: { setSession },
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang === "ar";

  const [state, updateState] = useState({
    engId: "",
    code: "",
    newPass: "",
    conPass: "",
    showNewPass: false,
    showConPass: false,

    isWrongPass: false,
    error: "",
  });

  function setState(nextState) {
    updateState((prevState) => ({
      ...prevState,
      ...nextState,
    }));
  }

  function handleChange(e) {
    let { name, value } = e.target;
    setState({ [name]: value });
    if (state.isWrongPass) setState({ isWrongPass: false });
  }

  function handleShow(show) {
    state[show] ? setState({ [show]: false }) : setState({ [show]: true });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    let { engId, code, newPass, conPass } = state;

    let reqBody = {
      engId,
      password: createPassword(newPass),
      code,
      username: engId,
      newPass: createPassword(newPass),
    };

    if (newPass == conPass) {
      let response = await fetchFromAPI({
        api: `auth/${props.route}`,
        reqBody,
      });

      if (response.status == "success") {
        if (response.response == "done")
          handleRouter({ href: "/signin", as: "/signin" });

        let user = response.response;
        setCookie("_id", user._id, 30);
        setCookie("authToken", user.authToken, 30);
        setSession({ user });
        handleRouter({ href: "/", as: "/" });
      } else {
        if (response.response) setState({ error: response.response });
      }
    } else {
      setState({ isWrongPass: true, showNewPass: true, showConPass: true });
    }
  }

  function getError() {
    return (
      <div className={"text-red w-fit mx-auto font-JR"}>
        {state.isWrongPass ? t("wrongPassword") : null}
        {state.error == "Wrong code" ? t("wrongCode") : null}
        {state.error == "Code already Used" ? t("codeUsed") : null}
        {state.error == "Account does not exist" ? t("doseNotExists") : null}
        {state.error == "Your request is pending approval"
          ? t("pendingReq")
          : null}
        {state.error == "The verification code has expired"
          ? t("expiredCode")
          : null}
        {state.error == "Request does not exist" ||
        state.error == "Request does not exists"
          ? t("requestDoesNotExist")
          : null}
      </div>
    );
  }

  return (
    <div className={`mb-5 w-full md:w-4/5 lg:w-2/3 xl:w-1/2`}>
      <div
        className={`flex items-center justify-center flex-col`}
      >
        <Text
          center
          bold
          sectionTitle
          text={
            props.route == "resetPassword"
              ? t("resetPassword")
              : t("confirmEnrollment")
          }
        />

<div className="mt-10 flex items-center justify-center w-full ">
        <form  className="w-full flex flex-col gap-2 " onSubmit={handleSubmit}>
            <Input
              required
              name="engId"
              value={state.engId}
              direction={isAr ? "rtl" : "ltr"}
              className={`input w-full`}
              leftIconName={"ic:baseline-engineering"}
              onChange={(e) =>
                handleChange({
                  target: {
                    name: e.target.name,
                    value: handleNumber(e.target.value),
                  },
                })
              }
              placeholder={t("engineerId")}
            />

            <Input
              required
              name="code"
              value={state.code}
              direction={isAr ? "rtl" : "ltr"}
              className={`input w-full`}
              onChange={(e) =>
                handleChange({
                  target: {
                    name: e.target.name,
                    value: handleNumber(e.target.value),
                  },
                })
              }
              placeholder={t("smsCode")}
            />

            <Input
              required
              name="newPass"
              direction={isAr ? "rtl" : "ltr"}
              isPasswordField
              value={state.newPass}
              className={`input w-full`}
              onChange={handleChange}
              placeholder={t("password")}
            />
            <Input
              required
              name="conPass"
              direction={isAr ? "rtl" : "ltr"}
              isPasswordField
              value={state.conPass}
              className={`input w-full`}
              onChange={handleChange}
              placeholder={t("retypePass")}
            />

            {getError()}
            <div className="w-full mt-5">
            <Button title={t("submit")} className="w-full" type="submit" />

            </div>

            <div className="w-fit mt-2">
              <div className="flex flex-row justify-start mb-2">
                <Text
                  text={t("facingProblem")}
                  className={"text-oeaMain text-input md:text-infoText "}
                />

                <Link href={`/enroll`} as={`/enroll`}>
                  <a>
                    <Text
                      className={
                        "text-oeaMain mx-2 hover:text-orange underline text-input md:text-infoText font-bold"
                      }
                      text={t("sendNewRequest")}
                    />
                  </a>
                </Link>
              </div>
              <div className="flex">
                <div className="flex flex-row justify-start">
                  <Text
                    text={t("alreadyHaveAccount")}
                    className={"text-oeaMain text-input md:text-infoText "}
                  />

                  <Link href={`/signin`} as={`/signin`}>
                    <a>
                      <Text
                        className={
                          "text-oeaMain mx-2 hover:text-orange underline text-input md:text-infoText font-bold"
                        }
                        text={t("signIn")}
                      />
                    </a>
                  </Link>
                </div>
              </div>
            </div>
        </form>
</div>
      </div>
    </div>
  );
}
